const TOAST_CONTAINER_ID = 'xha-notify-container';
const TOAST_AUTO_CLOSE_MS = 5000;

const COLORS = {
    error: '#F44336',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FF9800',
};

class Notify {
    toasts = new Map();

    toastId = 0;

    // ************** public ***************************************/

    showInfo = (message) => this.showToast(message, 'info');

    showError = (message) => this.showToast(message, 'error');

    showSuccess = (message) => this.showToast(message, 'success');

    showWarning = (message) => this.showToast(message, 'warning');

    isToastActive = (toastId) => this.toasts.has(toastId);

    dismissToastById = (toastId) => {
        const toast = this.toasts.get(toastId);
        if (toast) {
            toast.remove();
            this.toasts.delete(toastId);
        }
    };

    dismissAllToasts = () => {
        this.toasts.forEach((toast) => toast.remove());
        this.toasts.clear();
    }

    // ************** private **************************************/

    getContainer = () => {
        let container = document.getElementById(TOAST_CONTAINER_ID);
        if (!container) {
            container = document.createElement('div');
            container.id = TOAST_CONTAINER_ID;
            Object.assign(container.style, {
                left: '50%',
                position: 'fixed',
                top: '1rem',
                transform: 'translateX(-50%)',
                zIndex: 9999,
            });
            document.body.appendChild(container);
        }
        return container;
    }

    showToast = (message, type) => {
        if (typeof document === 'undefined') {
            return null;
        }

        const id = `toast-${Date.now()}-${this.toastId}`;
        this.toastId += 1;

        const toast = document.createElement('div');
        const closeButton = document.createElement('button');

        toast.textContent = message;
        Object.assign(toast.style, {
            backgroundColor: COLORS[type],
            boxShadow: '0 3px 6px rgba(0, 0, 0, 0.25)',
            color: '#fff',
            fontFamily: 'Arial, sans-serif',
            fontSize: '16px',
            lineHeight: '20px',
            marginBottom: '0.5rem',
            maxWidth: '420px',
            minHeight: '42px',
            minWidth: '320px',
            padding: '0.75rem 2.25rem 0.75rem 0.75rem',
            position: 'relative',
            whiteSpace: 'pre-wrap',
        });

        closeButton.setAttribute('aria-label', 'Close notification');
        closeButton.textContent = 'x';
        Object.assign(closeButton.style, {
            background: 'transparent',
            border: 0,
            color: '#fff',
            cursor: 'pointer',
            fontSize: '24px',
            fontWeight: 'bold',
            lineHeight: '20px',
            position: 'absolute',
            right: '0.5rem',
            top: '0.5rem',
        });

        closeButton.onclick = () => this.dismissToastById(id);
        toast.appendChild(closeButton);

        this.getContainer().appendChild(toast);
        this.toasts.set(id, toast);

        window.setTimeout(() => {
            this.dismissToastById(id);
        }, TOAST_AUTO_CLOSE_MS);

        return id;
    }
}

const notify = new Notify();
export default notify;
